<template>
  <ChartWrapper class="digital-chart" :status="status">
    <div class="bar-chart">
      <svg class="root" ref="root" />
    </div>
  </ChartWrapper>
</template>

<script>

import d3 from '@/utils/d3_importer'
import moment from 'moment';
import ChartWrapper from '@/components/IndicatorCards/parts/charts/ChartWrapper'
import colors from '@/mixins/colors'

let formatDate = (d)=>{
  let mnt = moment(d)
  let m = mnt.format('MMM').replace('.','')
  m = m.charAt(0).toUpperCase() + m.slice(1)
  let y = mnt.format('YY')
  return m+' '+y
}
export default {
  name: "DigitalBarChart",
  props: ['status','data','sector','compareData'],
  components:{
    ChartWrapper
  },
  mixins:[colors],
  data (){
    return {
      xScale: d3.scaleBand().padding(0.2),
      yScale: d3.scaleLinear(),
      // xSubScale: d3.scaleBand().padding(0.2),
    }
  },
  mounted () {
    if(this.data) this.drawChart()
  },
  computed: {
    legendItems () {
      return [
        {
          label:'Ventas Digital',
          class: 'primary'
        },
        {
          label:'Ventas Físicas',
          class: 'secondary'
        }
      ]
    },
    sectorsData(){
      return this.data && this.data.data[0].data
    },
    sectorsData2(){
      return this.compareData && this.compareData.data[0].data
    }
    // barsData(){
    //   return this.data.data[0].data.map((d)=>({value: d.data?d.data[0].value:0,valueDate: d.valueDate}))
    // },
    // barsData2(){
    //   return this.compareData && this.compareData.data[0].data.map((d)=>({value: d.data?d.data[0].value:0,valueDate: d.valueDate}))
    // }
  },
  methods: {
    drawChart(){
      let self = this
      if(!this.sectorsData) return
      // let barsData = this.data.data[0].data.map((d)=>({value: d.data?d.data[0].value:0,valueDate: d.valueDate}))
      let sectorsData = this.sectorsData && JSON.parse(JSON.stringify(this.sectorsData))
      let sectorsData2 = this.sectorsData2 && JSON.parse(JSON.stringify(this.sectorsData2))
      
      let height = this.$refs.root.clientHeight
      let width = this.$refs.root.clientWidth
      let margin= {left: 60, top: 20, right: 15, bottom: 50}
      let contentWidth = width - margin.left - margin.right
      let contentHeight = height - margin.top - margin.bottom

      this.xScale
        // .domain(d3.extent(sectorsData,(d)=>d.valueDate))
        .domain(sectorsData[0].data.map((d)=>new Date(d.valueDate)))
        .range([0, contentWidth])
      this.yScale
        // .domain(d3.extent(sectorsData,(d)=>d.value))
        .domain([0,100])
        .range([contentHeight, 0])
        
      // if(sectorsData2){
      //   this.xSubScale
      //     .domain([0,1])
      //     .range([-this.xScale.bandwidth()/2,this.xScale.bandwidth()/2]) //BASURA!
      // } else {
      //   this.xSubScale
      //     .domain([0,0])
      //     .range([0,0])
      // }
      
      let barWidth = this.xScale.bandwidth()
      
      let svg = d3.select(this.$refs.root)

      svg.append("text")
        .attr("transform", "rotate(-90)")
        .attr("y", 0)
        .attr("x",- (this.yScale(50) + margin.top))
        .attr("dy", "1em")
        .style("font-size", "10px")
        .style("text-anchor", "middle")
        .text(this.t('digital_evol_y_axis'))

      let xAxis = svg.selectAll('.x-axis').data([null])
      xAxis = xAxis.merge(xAxis.enter().append('g').attr('class','x-axis')).call(d3.axisBottom(this.xScale))
        .attr('transform',`translate(${margin.left},${height-margin.bottom + 10})`)
      xAxis.select('.domain').style('display','none')
      xAxis.selectAll('.tick').each(function(d){
        let str = formatDate(d)
        let m = str.split(' ')[0]
        let y = str.split(' ')[1]
        let txt = d3.select(this).select('text').text(null)
        d3.select(this).select('line').style('display','none')
        txt.append("tspan").attr("x", 0).attr("y", 10).text(m);
        txt.append("tspan").attr("x", 0).attr("y", 10).attr("dy", 1.7 + "em").text(y);
        // .attr("dy", ++lineNumber * lineHeight + dy + "em")
      })
      let yAxis = svg.selectAll('.y-axis').data([null])
      yAxis = yAxis.merge(yAxis.enter().append('g').attr('class','y-axis'))
        .call(d3.axisLeft(this.yScale).ticks(5).tickFormat((d)=>d+'%'))
        .attr('transform',`translate(${margin.left},${margin.top})`)
      yAxis.selectAll('.domain').style('opacity',0)
      yAxis.selectAll('.tick').select('line').style('opacity',0)
      
      let content = svg.selectAll('.content').data([null])
      content = content.merge(content.enter().append('g').attr('class','content'))
      content.attr('transform',`translate(${margin.left},${margin.top})`)
      
      let allData 
      if(sectorsData2){
        let comparedSector = sectorsData2.find((d)=>d.id === (this.sector || "commerce-sector-total"))
        // let comparedSector = sectorsData2.find((d)=>this.sector?(d.id === this.sector):(d.id==="commerce-sector-total"))
        
        if(comparedSector){
          comparedSector.compared = true
          allData = [...sectorsData,comparedSector]
        } else {
          allData = sectorsData
        }
      } else {
        allData = sectorsData
      }
      allData.forEach((d)=>d.cid = d.id+(d.compared?'_compared':''))
      
      let groups = content.selectAll('.group').data(allData,(d)=>d.cid)
      let groupsEnter = groups.enter().append('g').attr('class',(d)=>'group'+(d.compared?' compared':''))
      groups.exit().remove()
      groups = groups.merge(groupsEnter)
      
      
      groups.each(function (d){
        if(d.id==="commerce-sector-total") d3.select(this).raise()
        if(d.id===self.sector) d3.select(this).raise()
      })
      
      let bars = groups.selectAll('.bar').data((d,i)=>{
        return d.data.map((dd,j)=>({...dd,next:d.data[j+1] || null,sector:d.id,compared: d.compared}))
      })
      
     
      // let bars = content.selectAll('.bar').data(barsData)
      let barsEnter = bars.enter().append('g').attr('class','bar')
      // barsEnter.append('rect').attr('class',(d,i)=>'back-rect'+(i===0?'':' compared')+((self.compareData && i===0)?' noncompared':''))
      // barsEnter.append('rect').attr('class',(d,i)=>'front-rect'+(i===0?'':' compared'))
      barsEnter.append('line').attr('class','value-line').style('stroke-width',3)
      barsEnter.append('line').attr('class','value-line ghost').style('stroke-width',10)
      barsEnter.append('line').attr('class','joint').style('stroke-width',2)
      
      barsEnter.on('click',(d)=>{
        this.$emit('changeSector',d.sector)
      })
      // barsEnter.append('text').attr('class','main-value')
      // barsEnter.append('text').attr('class','second-value')

      bars.exit().remove()

      bars = bars.merge(barsEnter)
      
      bars.attr('transform',(d)=>`translate(${this.xScale(new Date(d.valueDate))+this.xScale.bandwidth()/2},0)`)
      // bars.select('.back-rect')
      //   .attr('x',(d,i)=>this.xSubScale(i)-barWidth/2)
      //   .attr('width',barWidth).attr('height',contentHeight)
      // bars.select('.front-rect').transition()
      //   .attr('x',(d,i)=>this.xSubScale(i)-barWidth/2)
      //   .attr('width',barWidth)
      //   .attr('height',(d)=>this.yScale(0)-this.yScale(d.value))
      //   .attr('y',(d)=>this.yScale(d.value))
      bars.select('.value-line').transition()
        .attr('x1',(d,i)=>-barWidth/2)
        .attr('x2',(d,i)=>+barWidth/2)
        .attr('y1',(d)=>this.yScale(d.value))
        .attr('y2',(d)=>this.yScale(d.value))
        .style('opacity',(d)=>(d.value!==undefined)?1:0)
        .attr('stroke',(d)=>{
          if(d.compared) return this.bsRose
          else if(d.sector==="commerce-sector-total"){
            if(d.sector===this.sector || !this.sector) return this.bsBlue
            else if(!sectorsData2) return 'rgba(0,0,0,0.7)'
            else return 'rgba(0,0,0,0.05)'
          } 
          else if (d.sector===this.sector) return this.bsBlue
          else return 'rgba(0,0,0,0.05)'
        })
      bars.select('.ghost').transition()
        .attr('x1',(d,i)=>-barWidth/2)
        .attr('x2',(d,i)=>+barWidth/2)
        .attr('y1',(d)=>this.yScale(d.value))
        .attr('y2',(d)=>this.yScale(d.value))
        .style('opacity',0)
        .attr('stroke','rgba(0,0,0,1)')
      bars.select('.joint').transition()
        .attr('x1',(d,i)=>barWidth/2)
        .attr('x2',(d,i)=>barWidth/0.8-barWidth/2)
        .attr('y1',(d)=>this.yScale(d.value))
        .attr('y2',(d)=>this.yScale(d.next ? d.next.value : 0))
        .style('opacity',(d)=>(d.value!==undefined && d.next && d.next.value!==undefined)?0.3:0)
        .attr('stroke',(d)=>{
          if(d.compared) return this.bsRose
          else if(d.sector==="commerce-sector-total"){
            if(d.sector===this.sector) return this.bsBlue
            else if(!sectorsData2) return 'rgba(0,0,0,0.7)'
            else return 'rgba(0,0,0,0.05)'
          } 
          else if (d.sector===this.sector) return this.bsBlue
          else return 'rgba(0,0,0,0.05)'
        })
        

      
      // bars.select('.main-value')
      //   .attr('x',(d,i)=>0)
      //   .attr('y',(d)=>this.yScale(d.value))
      //   .text((d)=>d.value?(Math.round(d.value)+'%'):'')
      //   .attr('dy','3px')
        //.classed('flipped',(d)=>d.value>this.yScale.domain()[1])
      // bars.select('.second-value')
      //    .attr('x',(d,i)=>0)
      //    .attr('y',(d)=>this.yScale(d.value))
      //    .text((d)=>d.value?(Math.round(100 - d.value)+'%'):'')
      //    .attr('dy','-3px')
         //.classed('flipped',(d)=>d.value>this.yScale.domain()[1])
      
      /*let refLine = svg.selectAll('.ref-line').data([null])
      let refLineEnter = refLine.enter().append('g').attr('class','ref-line')
      refLineEnter.append('line')
      refLineEnter.append('text').text('100%').attr('dx',0).attr('dy',-5)
      refLine = refLine.merge(refLineEnter)
      refLine.attr('transform',`translate(0,${this.yScale(100)+margin.top})`)
      refLine.select('line').attr('x1',0).attr('x2',contentWidth)*/
    }
  },
  watch: {
    data () {
      this.drawChart()
    },
    compareData () {
      this.drawChart()
    },
    sector () {
      this.drawChart()
    }
  }
}
</script>

<style lang="stylus" scoped>
.digital-chart
  .bar-chart
    height: vh(300px)
    width: 100%
    svg
      width 100%
      height 100%
      font-family: Lato
      >>> .bar
        .back-rect
          fill $bs-blue
          opacity 0.3
          &.noncompared
            fill $bs-blue
            opacity 0.3
          &.compared
            fill $compare-color
            opacity 0.3
        .front-rect 
          fill $bs-blue
          &.compared
            fill $compare-color
        .main-value, .second-value
          margin-left 4px
          font-family: 'Lato'
          m-font-size(8,10)
          font-weight bold
          dominant-baseline: text-before-edge;
          text-anchor: middle
          // text-anchor: middle;
          fill: #222
          &.flipped
            //dominant-baseline: text-before-edge;
            fill: #fff;
          .desktop &
            m-font-size(10,12)
        .second-value
          dominant-baseline: text-after-edge;
      >>> .ref-line
        line
          stroke: #666;
          stroke-width: 0.5px;
          shape-rendering: crispedges;
        text
          font-size 12px
</style>